<template>
  <header>
    <div class="info">
      <div class="logo">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 358.4 342.4">
          <path fill="#010202" d="M256.4 340c-9.9 0-52.4-44.5-60.8-55.4-5.2-6.7-11.2-17.8-11.2-27.1v-47.2c0-4.4-2.6-6.7-5.1-6.7s-5.1 2.3-5.1 6.7v47.2c0 9.3-6.1 20.4-11.2 27.1-8.4 10.9-51 55.4-60.8 55.4-10 0-21.5-6.1-53.2-38.3-7.7-7.8-38.7-65.6-42.5-86.3-7.6-42.2-2.2-102.8 0-115.2 2.3-13.3 22.4-50.9 30.7-59.4C45.6 32.2 94.7 2.5 110 2.5h138.7c15.3 0 64.4 29.7 72.8 38.3 8.3 8.6 28.4 46.1 30.7 59.4 2.2 12.5 7.6 73 0 115.2-3.8 20.8-34.8 78.5-42.5 86.3-31.9 32.2-43.3 38.3-53.3 38.3z"/>
          <path fill="#FFF" d="M248.5 4.9c13.9 0 62.3 28.6 71 37.5 8 8.2 27.9 45.4 30 58.1 2.1 12.4 7.6 72.4 0 114.4-3.6 19.8-34.4 77.6-41.8 85-34.2 34.7-43.5 37.5-51.4 37.5-8.7-.3-49.8-42.8-58.9-54.4-5-6.4-10.7-17-10.7-25.6v-47.2c0-6-3.8-9.2-7.6-9.2s-7.6 3.1-7.6 9.2v47.2c0 8.7-5.8 19.2-10.7 25.6-9.1 11.7-50.2 54.1-58.9 54.5-7.9 0-17.2-2.8-51.4-37.5-7.4-7.5-38.2-65.2-41.8-85.1-7.6-41.9-2.1-102 0-114.4 2.2-12.7 22.1-50 30.1-58.1 8.8-9 57.1-37.5 71-37.5h138.7m0-4.9h-68.1-70.6C93.7 0 44.1 30 35.3 39 26.5 48 6.3 86.3 4 99.7 1.7 113-3.7 173.6 4 215.8c3.8 21.2 35.2 79.6 43.1 87.6 33.5 34 44.6 39 54.9 39 12.1 0 57-48.9 62.7-56.3 5.8-7.4 11.8-18.8 11.8-28.6v-47.2c0-2.8 1.3-4.3 2.7-4.3 1.3 0 2.7 1.4 2.7 4.3v47.2c0 9.8 6 21.2 11.8 28.6 5.8 7.4 50.7 56.3 62.7 56.3 10.3 0 21.4-5 54.9-39 7.9-8 39.3-66.4 43.1-87.6 7.6-42.2 2.3-102.7 0-116.1C352.1 86.3 331.8 48 323 39c-8.7-9-58.3-39-74.5-39z"/>
          <g>
            <g fill="#FFF">
              <path d="M97.4 145.5l-5.5-24.1 24.9 18.5z"/>
              <path d="M135.7 145.5l5.5-24.1-24.9 18.5z"/>
            </g>
            <path fill="#FFF" d="M94.8 164.2L65.3 130l38.3 9.9 13.5-27.3 13.4 27.3 37.4-9.9-28.5 34.2z"/>
            <path fill="#010202" d="M117.1 115.3l12 24.3.9 1.7 1.9-.5 32.8-8.7-25.9 30.9H95.3l-26.7-30.8 33.7 8.7 1.9.5.9-1.7 12-24.4m0-5.4L103 138.5l-41-10.6 32.3 37.4h45.6l31.3-37.4-40 10.6-14.1-28.6z"/>
          </g>
        </svg>
      </div>
      <div class="who">Magnus Voll Mathiassen aka MVM</div>
      <div class="what">Art and Art Direction</div>
    </div>
    <div class="contact">
      <div class="instagram">
        <a href="https://www.instagram.com/mvm_magnus/" target="_blank">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.3 36.3">
            <g fill="none" stroke="#010202" stroke-miterlimit="10" stroke-width="1.3753">
              <path d="M35.6 30.7c0 2.7-2.2 4.9-4.9 4.9H5.6c-2.7 0-4.9-2.2-4.9-4.9V5.6C.7 2.9 2.9.7 5.6.7h25.1c2.7 0 4.9 2.2 4.9 4.9v25.1z"/>
              <circle cx="17.8" cy="18.1" r="10.1"/>
              <circle cx="28.6" cy="6.6" r="3.1"/>
            </g>
          </svg>
        </a>
      </div>
      <div class="contact-header-wrapper">
        <h2 class="contact-header d-none d-sm-block contact-header-sticky">
          <router-link :to="{ name: 'info' }">
            Contact & Info
          </router-link>
        </h2>
      </div>
      <h2 class="contact-header d-block d-sm-none">
        <router-link :to="{ name: 'info' }">
          Contact<br>&<br>Info
        </router-link>
      </h2>
      <p>
        <strong>Phone</strong> +47 95876290<br>
        <strong>Email</strong> <a href="mailto:mvm@themvm.com" class="plain">mvm@themvm.com</a>
      </p>

      <p>
        <strong>Address</strong><br>
        DRMA, Magnus Voll Mathiassen<br>
        Torgeir Vraas plass 6<br>
        3044 Drammen<br>
        Norway
      </p>
    </div>
  </header>
</template>

<script>
import { TweenMax } from 'gsap'

export default {
  name: 'MVMHeader',
  props: {
    msg: String
  },

  data () {
    return {
      $sticky: null,
      stickyTop: null,
      stickyBot: null,
      stickyHeight: null,
      scrollTop: 0,
      scrollDirection: null,
      fixed: false
    }
  },

  mounted () {
    let info = document.querySelector('header .info')
    let contact = document.querySelector('header .contact')

    TweenMax.set([info, contact], { autoAlpha: 0 })
    TweenMax.staggerTo([info, contact], 1, { autoAlpha: 1, delay: 0.35 }, 0.25)
  }
}
</script>
